// polyfill for remove() method in Internet Explorer 9 and higher
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function(arr) {
  arr.forEach(function(item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) this.parentNode.removeChild(this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// polyfill for Internationalization APIs to support
// react-intl in older browsers
if (!global.Intl) {
  global.Intl = require('intl');
  require('intl/locale-data/jsonp/en.js');
}



// WEBPACK FOOTER //
// ./app/javascript/apps/application/polyfills.js